import { makeAutoObservable } from 'mobx';
import { LIMIT_PER_PAGE } from '../utils/consts';

export default class DetailStore {
  constructor() {
    this._types = [];
    this._subTypes = [];
    this._brands = [];
    this._details = [];
    this._searchResults = [];
    this._selectedType = {};
    this._selectedSubType = {};
    this._selectedBrand = {};
    this._page = 1;
    this._totalCount = 0;
    this._limit = LIMIT_PER_PAGE;
    this._searchQuery = '';
    this._isSearching = false;
    this._isLoading = false;
    makeAutoObservable(this);
  }

  setTypes(types) {
    this._types = types || [];
    this._subTypes = types.flatMap((type) => type.subTypes || []) || [];
  }

  setSubTypes(subTypes) {
    this._subTypes = subTypes || [];
  }

  setBrands(brands) {
    this._brands = brands || [];
  }

  setDetails(details) {
    this._details = details || [];
  }

  setSearchResults(results) {
    this._searchResults = results || [];
  }

  setSelectedType(type) {
    this.setPage(1);
    this._selectedType = type || {};
    this._selectedSubType = {}; 
  }

  setSelectedSubType(subType) {
    this.setPage(1);
    this._selectedSubType = subType || {};
  }

setSelectedBrand(brand) {
    this.setPage(1);
    this._selectedBrand = brand || {};
  }

  setPage(page) {
    this._page = page;
  }

  setTotalCount(count) {
    this._totalCount = count;
  }

  setSearchQuery(query) {
    this._searchQuery = query || '';
    this._isSearching = !!query;
    this.setPage(1);
  }

  clearSearchQuery() {
    this._searchQuery = '';
    this._isSearching = false;
    this._searchResults = [];
    this.setPage(1);
  }

  setIsSearching(isSearching) {
    this._isSearching = isSearching;
  }

  setIsLoading(isLoading) {
    this._isLoading = isLoading;
  }

  get types() {
    return this._types;
  }

  get subTypes() {
    return this._subTypes;
  }

  get brands() {
    return this._brands;
  }

  get details() {
    return this._isSearching ? this._searchResults : this._details;
  }

  get searchResults() {
    return this._searchResults;
  }

  get selectedType() {
    return this._selectedType;
  }

  get selectedSubType() {
    return this._selectedSubType;
  }

  get selectedBrand() {
    return this._selectedBrand;
  }

  get totalCount() {
    return this._totalCount;
  }

  get page() {
    return this._page;
  }

  get limit() {
    return this._limit;
  }

  get searchQuery() {
    return this._searchQuery;
  }

  get isSearching() {
    return this._isSearching;
  }

  get isLoading() {
    return this._isLoading;
  }
}